import {Route, Switch, useRouteMatch} from "react-router";
import {BrowserRouter as Router, Link} from "react-router-dom";
import {WsGroupsEdit} from "./pages/WsGroupsEdit";
import React, {useCallback, useEffect, useState} from "react";
import {Store} from "../models/Store";
import './admins/AdminApp.scss';
import {AdminUndoneListPage} from './AdminUndoneListPage';

export const AdminApp = () => {
    let {path} = useRouteMatch();

    const [isLogin, setLogin] = useState(Store.auth.isLogin());

    useEffect(() => {
        document.body.classList.add('admin');

        // <link rel="stylesheet" href="./css/milligram.css">
        const e = document.createElement('link');
        e.rel = "stylesheet";
        e.href = "./css/milligram.css";
        document.querySelector('head')?.appendChild(e);

    }, []);

    useEffect(()=>{
        Store.auth.onLogin(()=>{
            setLogin(true);
        });
    },[]);

    const onLogin = useCallback(()=>{
        setLogin(true);
    },[]);

    return (

        <Router basename={Store.routerBasename}>

            <div className='admin'>

                <link rel="stylesheet" href="//fonts.googleapis.com/css?family=Roboto"/>
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Roboto:300,300italic,700,700italic"/>
                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/normalize/8.0.1/normalize.css"/>
                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/milligram/1.4.1/milligram.css"/>

                {

                    !isLogin && <BeforeLogin onLogin={onLogin}/>
                }

                {
                    isLogin && <AfterLogin/>
                }

            </div>
        </Router>
    );
};

enum RecruitingState {
    Recruiting = 'recruiting', Not = 'notrecruiting'
}

const AfterLogin=()=>{
  return (<div>
      <Switch>
          // グループ編集画面
          <Route path={`/admin/ws/groups/edit/:id`} children={<WsGroupsEdit/>}/>

          // グループ作成画面
          <Route path={`/admin/ws/groups/create`} children={<WsGroupsEdit/>}/>

          // グループ一覧画面
          <Route path={`/admin/ws/groups`}>
              <WsGroups/>
          </Route>

          // ワークショップトップ
          <Route path={`/admin/ws`}>
              <WsTop/>
          </Route>

          //
          <Route path='/admin/undone'><AdminUndoneListPage/></Route>

          //
          <Route path='/admin/opened'><AdminOpenedPage/></Route>

          // テスト
          <Route path={'/admin/test'}>
              <AdminUndoneListPage/>
          </Route>

          // 管理画面トップ
          <Route path={`/admin`}>
              <AdminTop/>
          </Route>
      </Switch>
  </div>);
};

const BeforeLogin = (props:{onLogin:()=> void}) => {

    const [email, setEmail] = useState<string>('');
    const [password, setPassword] = useState<string>('');

    const onLoginButtonClick = useCallback(() => {
        console.log(email, password);
        (async () => {
            const res = await Store.auth.aaa(email, password);
            if(res) props.onLogin();
        })();
    }, [email, password]);

    return (<div>
        <h6>ひかりの実スマイルアトリエ</h6>
        <h1>管理画面</h1>

        <hr/>
        <div><label htmlFor="">ユーザーID</label><input type="text" value={email}
                                                    onChange={e => setEmail(e.currentTarget.value)}
                                                    style={{width: '400px'}}/></div>
        <div><label htmlFor="">パスワード</label><input type="password" value={password}
                                                   onChange={e => setPassword(e.currentTarget.value)}
                                                   style={{width: '400px'}}/></div>
        <div>
            <button onClick={onLoginButtonClick}>ログイン</button>
        </div>
    </div>);
};

const AdminTop = () => {

    return (<div>
        <h6>ひかりの実スマイルアトリエ</h6>
        <h1>管理画面</h1>

        <hr/>
        {/*<div><Link to={`${url}/fs`}>*/}
        {/*    <button>フリースペース設定</button>*/}
        {/*</Link></div>*/}
        {/*<hr/>*/}
        <h2>ワークショップの設定をする</h2>
        <div><Link to={`/admin/ws`}>
            <button>ワークショップ設定</button>
        </Link></div>

        <hr/>

        <h2>未完了の笑顔を検索・更新する</h2>
        <Link to="/admin/undone"><button>未完了笑顔検索</button></Link>

        <hr/>

        <h2>募集をクローズする</h2>
        <div><Link to={`/admin/opened`}><button>募集設定</button></Link></div>
    </div>);
};

const WsGroups = () => {
    const [groupIds, setGroupIds] = useState<string[]>([]);

    useEffect(() => {
        (async () => {
            const groupIds = await Store.firestore_ws_fetchGroupIds();
            setGroupIds(groupIds);
        })();
    }, []);

    return (<div className={'workshop-admin'}>
        <h6>ひかりの実スマイルアトリエ > 管理画面 > ワークショップ設定</h6>
        <h1>グループ一覧</h1>

        <Link to={'/admin/ws'}>&lt;&nbsp;戻る</Link>

        <hr/>

        <h2>新規にグループを作成</h2>

        <Link to={'/admin/ws/groups/create'}>
            <button>グループ作成</button>
        </Link>

        <hr/>

        <h2>既存グループを変更</h2>

        {
            groupIds.map(item => (
                <div key={item}><Link to={'/admin/ws/groups/edit/' + item}>
                    <button>{item}</button>
                </Link></div>
            ))
        }
    </div>)
};

const WsTop = () => {
    return <div>
        <h6>ひかりの実スマイルアトリエ > 管理画面</h6>
        <h1>ワークショップ設定</h1>
        <Link to={`/admin`}>&lt;&nbsp;戻る</Link>
        <hr/>
        <WsTopConfigRecruiting/>
        <hr/>
        <h3>グループ個別の設定</h3>
        <div><Link to={`/admin/ws/groups`}>
            <button>グループ一覧</button>
        </Link></div>
    </div>;
};

const WsTopConfigRecruiting = () => {
    const [isRecruiting, setIsRecruiting] = useState<RecruitingState>(RecruitingState.Not);

    const onRecruitingStateChange = useCallback(((e) => {
        setIsRecruiting(e.target.value);
    }), []);

    useEffect(() => {
        (async () => {
            const isRecruiting = await Store.config.isRecruiting();
            setIsRecruiting(isRecruiting ? RecruitingState.Recruiting : RecruitingState.Not);
        })();
    }, []);

    const onSaveButtonClick = useCallback(() => {
        Store.config.updateRecruiting(isRecruiting === RecruitingState.Recruiting);
    }, [isRecruiting]);

    return (<div>
        <h3>「募集中ではありません」画面の設定</h3>
        <div>
            <label><input type="radio" name='recruitingstate' value={RecruitingState.Not}
                          checked={isRecruiting === RecruitingState.Not}
                          onChange={onRecruitingStateChange}/>&nbsp;募集中ではないので「募集中ではありません」ページを表示する</label>
            <label><input type="radio" name='recruitingstate' value={RecruitingState.Recruiting}
                          checked={isRecruiting === RecruitingState.Recruiting}
                          onChange={onRecruitingStateChange}/>&nbsp;募集中なので通常のページを表示する</label>
        </div>
        <button onClick={onSaveButtonClick}>保存</button>
    </div>);
};

const AdminOpenedPage = ()=>{
    const [currentGroups, setCurrentGroups] = useState('');

    useEffect(()=>{
        (async () => {
            const r = await Store.firestore_getCurrentGroups();
            setCurrentGroups(r);
        })();
    },[])

    const onSaveButtonClick = useCallback(()=>{
        Store.firestore_updateCurrentGroups(currentGroups);
    },[currentGroups]);

    return <div>
        <h6>ひかりの実スマイルアトリエ > 管理画面</h6>
        <h1>実施中のグループID</h1>
        <Link to={`/admin`}>&lt;&nbsp;戻る</Link>
        <hr/>
        <p>改行で区切ってください</p>
        <textarea style={{height:'400px'}} value={currentGroups} onChange={e => setCurrentGroups(e.target.value)}></textarea>
        <button onClick={onSaveButtonClick}>保存</button>
    </div>;
};